import { memo, Fragment } from "react";

// header
import Headerpro from "../../components/partials/pro/headerstyle/header-pro";

//sidebar
import Sidebar from "../../components/partials/dashboard/sidebarstyle/sidebar";

//footer
import Footer from "../../components/partials/dashboard/footerstyle/footer";

//default
import DefaultRouter from "../../router/default-router";

//seetingoffCanvas
import SettingOffCanvas from "../../components/setting/SettingOffCanvas";

import Loader from "../../components/Loader";

// Import selectors & action from setting store
import * as SettingSelector from "../../store/setting/selectors";
// Redux Selector / Action
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const Default = memo(() => {
  const pageLayout = useSelector(SettingSelector.page_layout);
  const appName = useSelector(SettingSelector.app_name);
  const location = useLocation();
  const isWideMenuPage =
    /^\/shops\/?$/.test(location.pathname) ||
    /^\/shop\/[^/]+\/cover-images\/?$/.test(location.pathname) ||
    /^\/business-analysis\/?$/.test(location.pathname);

  var subHeader = "";
  var commanclass = "";

  return (
    <Fragment>
      <Loader />
      <Sidebar app_name={appName} isWideMenuPage={isWideMenuPage} />
      <main className={`main-content`} style={{ backgroundColor: "#EEF2F6" }}>
        <div className={`${commanclass} position-relative `}>
          <Headerpro />
          {subHeader}
        </div>

        <div className={` ${pageLayout} content-inner pb-0 ${isWideMenuPage ? "shops-page-content" : ""}`}>
          <DefaultRouter />
        </div>
        <Footer />
      </main>
      <SettingOffCanvas />
    </Fragment>
  );
});

Default.displayName = "Default";
export default Default;
